import { useState } from "react";
import { Clock, CheckCircle2 } from "lucide-react";
import { V3Page, V3Aside, Field, Pill, V3Actions } from "@/components/control/v3";

// C110: the shared building blocks rendered live from the same components the Control OS uses.
export default function SharedComponents() {
  const [value, setValue] = useState("");
  const [checked, setChecked] = useState(false);
  const error = checked && !value.trim() ? "Bitte einen Wert eingeben. Das Feld ist ein Pflichtfeld." : null;
  return (
    <V3Page crumb="Übersicht" title="Gemeinsame Komponenten prüfen" subtitle="Vergleiche dieselben Bausteine in Mitglieder-App, Organisation und Control OS."
      aside={<V3Aside subject="Gemeinsame Spezifikation: docs/api/shared-contract.md" note="Die Umsetzung in Mitglieder- und Organisations-App prüfen die jeweiligen App-Teams gegen dieselbe Spezifikation." />}
      testId="shared-components-page">
      <Field label="Primäraktion">Magenta · Eindeutige Handlungsbezeichnung</Field>
      <Field label="Status">Text und Symbol zusätzlich zur Farbe</Field>
      <Field label="Formulare">Sichtbare Beschriftung und verständlicher Fehler</Field>
      <Field label="Navigation">Gleiche aktive Kennzeichnung in allen drei Apps</Field>
      <h2 className="pt-2 text-lg font-bold text-brand-purple">Bausteine im Vergleich</h2>
      <V3Actions primary="Änderung prüfen" onPrimary={() => setChecked(true)} secondary={null} testId="components-demo" />
      <div className="flex flex-wrap gap-3 py-1">
        <Pill testId="components-pill-open"><Clock className="mr-1 h-3.5 w-3.5" aria-hidden="true" />Anfrage offen</Pill>
        <Pill tone="success" testId="components-pill-done"><CheckCircle2 className="mr-1 h-3.5 w-3.5" aria-hidden="true" />Bestätigt</Pill>
      </div>
      <label htmlFor="components-field" className="flex flex-col gap-1.5">
        <span className="font-bold text-brand-purple">Beschriftetes Formularfeld</span>
        <input id="components-field" value={value} onChange={(e) => setValue(e.target.value)} placeholder="Noch nicht eingegeben" data-testid="components-field"
          aria-invalid={!!error} aria-describedby={error ? "components-field-error" : undefined}
          className={`h-11 rounded-xl border bg-white px-3 text-base focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-magenta ${error ? "border-red-500" : "border-[#E6E1F0]"}`} />
        {error && <span id="components-field-error" role="alert" className="text-sm text-red-700" data-testid="components-field-error">{error}</span>}
        {checked && !error && <span className="text-sm text-green-800" data-testid="components-field-ok">Eingabe gültig.</span>}
      </label>
    </V3Page>
  );
}
